import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { Util } from '../shared/util.service';
import { JsonReturn, ObjectParam } from '../interface/generic-interface';

@Injectable()
export class MainContainerService {

  listaOcorrencias: any[] = [];
  listaOcorrenciasPorData: any[] = [];
  listaOcorrenciasMsg: any[] = [];
  listaOcorrenciaLogs: any[] = [];
  listaRoteiros: any[];
  listOcorrenciasRoteiroStatus: any[] = [];
  totalRoteiros: number;
  roteiroSelecionado: number;
  ocorrenciaSelecionado: any[] = [];
  atualizacaoOcorrencia = true;
  listaRoteiroFiltro: any[] = [];
  loadingProcessando = false;
  descricaoMotoAjudante = ''
  ajudantes = [];
  listaPedidosNotas: any[] = [];
  loadingListaPedidosNotas = false;
  pedidosOcorrenciaAtual = '';
  notasOcorrenciaAtual = '';


  constructor(
    private conService: ApiConService,
    private util: Util,
  ) { }



  async getCarregaOcorrencias() {
    try {
      const response: JsonReturn = await this.conService.patch('DCocorrencias');
      this.listaOcorrencias = response.response;
      return this.listaOcorrencias
    }
    catch (e) {
      console.log(e);
    }
  }
  async getCarregaOcorrenciasPorData() {
    try {
      const response: JsonReturn = await this.conService.patch('DCocorrencias/PorData');
      this.listaOcorrenciasPorData = response.response;
      console.log('Lista de Ocorrencias por Data ----------------------------------' + this.listaOcorrenciasPorData );
      return this.listaOcorrenciasPorData
    }
    catch (e) {
      console.log(e);
    }
  }

  async getCarregaRoteiros() {
    try {
      const response: JsonReturn = await this.conService.patch('DCroteiros/resumoOC');

      this.listaRoteiros = response.response;
      this.totalRoteiros = this.listaRoteiros.length;

      await this.separaOcorrenciasPorStatus(true);
    }
    catch (e) {
      console.log(e);
    }
  }

  async getCarregaRoteirosId(Id) {
    try {
      const response: JsonReturn = await this.conService.patch('DCroteiros/SemResultadoRota/' + Id);
      this.listaRoteiros = response.response;
      await this.separaOcorrenciasPorStatus(false);
    } catch (Error) {
        console.log("CATCH________getCarregaRoteirosId");
        console.log(Error);
    }
  }

  async getCarregaRoteirosData(Id) {
    try {
      const response: JsonReturn = await this.conService.patch('DCroteiros/data/' + Id);
      this.listaRoteiros = response.response;
      await this.separaOcorrenciasPorStatus(false);
    } catch (Error) {
        console.log("CATCH________getCarregaRoteirosData");
        console.log(Error);
    }
  }

  async getAlertaId(id) {
    try {
      const response: JsonReturn = await this.conService.patch('DCRoteiroAlerta/dadosPorID/' + id);
      return response.response;
    } catch (error) {
      console.log(error)
     }
  }

  async updateAlertaId(id: number, objParam: ObjectParam) {
    try {
      const response = await this.conService.put('DCRoteiroAlerta' , `${id}`, objParam);
      return response;
    } catch (Error) {
        console.log("CATCH________updateAlertaId");
        console.log(Error);
    }
  }  

  async getCarregaRoteirosPedido(Pedido) {
    try {
      const response: JsonReturn = await this.conService.patch('DCroteiros/pedido/' + Pedido);
      this.listaRoteiros = response.response;
      await this.separaOcorrenciasPorStatus(false);
    } catch (Error) {
        console.log("CATCH________getCarregaRoteirosPedido");
        console.log(Error);
    }
  }

  async getCarregaRoteirosCliente(Cliente) {
    try {
      const response: JsonReturn = await this.conService.patch('DCroteiros/cliente/' + Cliente);
      this.listaRoteiros = response.response;
      await this.separaOcorrenciasPorStatus(false);
    } catch (Error) {
        console.log("CATCH________getCarregaRoteirosCliente");
        console.log(Error);
    }
  }



  async separaOcorrenciasPorStatus(alteracaoStatus: boolean) {

    if (this.ocorrenciaSelecionado.length > 0 && alteracaoStatus) {
      this.util.ocorrenciaAlterada = this.ocorrenciaSelecionado[0].CodigoOcorrencia;
    }

    this.listaOcorrencias = await this.getCarregaOcorrencias()
    for (let i = 0; i < this.listaRoteiros.length; i++) {
      if (this.listaRoteiros[i].qtdOcorrenciasPorStatus === undefined) {
        this.listaRoteiros[i].qtdOcorrenciasPorStatus = {
          'novo': [],
          'analise': [],
          'finalizado': []
        };
      }
      for (let x = 0; x < this.listaOcorrencias.length; x++) {
        if (Number(this.listaRoteiros[i].roteiro) === Number(this.listaOcorrencias[x].NumeroRoteiro)) {
          switch (this.listaOcorrencias[x].IdStatus) {
            case 1:
              this.listaRoteiros[i].qtdOcorrenciasPorStatus.novo.push(this.listaOcorrencias[x]);
              break;
            case 2:
              this.listaRoteiros[i].qtdOcorrenciasPorStatus.analise.push(this.listaOcorrencias[x]);
              break;
            case 3:
              this.listaRoteiros[i].qtdOcorrenciasPorStatus.finalizado.push(this.listaOcorrencias[x]);
              break;
          }
        }
      }
    }


    setTimeout(() => {
      this.util.ocorrenciaAlterada = '';
      alteracaoStatus = false;
    }, 1000);
  }

  async apagaOcorrenciasPorStatus() {
    for (let i = 0; i < this.listaRoteiros.length; i++) {
      if (this.listaRoteiros[i].qtdOcorrenciasPorStatus !== undefined) {
        this.listaRoteiros[i].qtdOcorrenciasPorStatus.novo = [];
        this.listaRoteiros[i].qtdOcorrenciasPorStatus.analise = [];
        this.listaRoteiros[i].qtdOcorrenciasPorStatus.finalizado = [];
      }
    }
  }

  async getVisualizarOcorrenciasDoRoteiro(roteiro) {

    this.roteiroSelecionado = roteiro;
    this.listOcorrenciasRoteiroStatus = [];

    for (let i = 0; i < this.listaRoteiros.length; i++) {
        if (Number(this.listaRoteiros[i].roteiro) === Number(this.roteiroSelecionado)) {
        let item = this.listaRoteiros[i];  
        let infoRota = typeof(item.InfoRota) == 'string'? JSON.parse(item.InfoRota) : item.InfoRota;

        this.ajudantes = []
        if (infoRota.PermitiAcessoAjudante === true) {
          this.descricaoMotoAjudante = 'Motorista / Ajudante ';
          if(infoRota.Ajudante){
            infoRota.Ajudante.forEach((ajudante) => {
              this.ajudantes.push({nomeAjudante: ajudante.nome})
            })
          }else {
            this.ajudantes.push({nomeAjudante: infoRota.NomeAjudante})
          }
      } else {
        this.ajudantes = [];
        this.descricaoMotoAjudante = 'Motorista';
      }        
        
        if (item.InfoRota.Data == undefined) { item.InfoRota = JSON.parse(item.InfoRota); }
        await this.listOcorrenciasRoteiroStatus.push(item);
        return;
      }
    }
  }
}
